export default __webpack_public_path__ + "static/media/group.7144432b.svg";